// static/src/composables/useFavicon.js
//
// Real gap reported live 2026-09-10 (owner, quoting the /features page's
// own white-label pitch: "Custom logo, favicon, and brand colors...
// Your clients never see 'LeadRanks' anywhere" -- but the browser tab's
// favicon stayed LeadRanks' own everywhere, including on a client-facing
// shared report). static/index.html's <link rel="icon"> tags are static
// HTML, identical for every visitor -- there was no code anywhere that
// ever changed them based on white-label branding. Swapping them at
// runtime, once branding is known, is the standard approach (a favicon
// can't be templated server-side the way index.html's <title>/meta tags
// theoretically could, since it's just a <link href>).
//
// Single SSOT for this so BOTH call sites -- the agency's own
// authenticated app (stores/whiteLabelStore.js, whenever branding is
// active) and a client's public shared-report view (SharedReportPage.vue,
// which never touches the Pinia white-label store at all) -- stay in
// sync rather than each re-implementing their own DOM-query logic.

var ICON_SELECTOR = 'link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]';
var ORIGINAL_HREFS = null; // captured lazily, once, before the first swap

function _captureOriginals() {
  if (ORIGINAL_HREFS) return;
  ORIGINAL_HREFS = [];
  var links = document.querySelectorAll(ICON_SELECTOR);
  for (var i = 0; i < links.length; i++) {
    ORIGINAL_HREFS.push({ el: links[i], href: links[i].getAttribute('href') });
  }
}

/**
 * Point every favicon/apple-touch-icon <link> at the given logo URL.
 * Safe to call repeatedly (e.g. on every branding fetch) -- a no-op if
 * logoUrl is falsy.
 */
export function injectFavicon(logoUrl) {
  if (!logoUrl) return;
  try {
    _captureOriginals();
    var links = document.querySelectorAll(ICON_SELECTOR);
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('href', logoUrl);
    }
  } catch (_e) { /* non-critical cosmetic feature -- never break the page over this */ }
}

/** Restore LeadRanks' own favicon/apple-touch-icon hrefs. */
export function resetFavicon() {
  if (!ORIGINAL_HREFS) return; // nothing was ever swapped
  try {
    for (var i = 0; i < ORIGINAL_HREFS.length; i++) {
      ORIGINAL_HREFS[i].el.setAttribute('href', ORIGINAL_HREFS[i].href);
    }
  } catch (_e) { /* non-critical cosmetic feature -- never break the page over this */ }
}
